// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ih95","paramInput":"JobSimulator_paramInput__3iqA6","input":"JobSimulator_input__Do8jX"};